module.exports = __webpack_public_path__ + "static/media/homework-completion-screen-header.673ad6bb.png";